export const APP_LOCAL_KEYS = {
    DAY_TIME: "r20DayTime",
    SECTION_NAME: "r20SectionName",
};
